import { can } from '@simplificalo/contracts/permissions';
import { createFileRoute } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import { useState } from 'react';

import { AddMemberModal } from '@/components/equipo/AddMemberModal';
import { MemberList } from '@/components/equipo/MemberList';
import { Button } from '@/components/ui/button';
import { useCurrentUserRole, useTeamMembers } from '@/lib/team';

// Sprint Settings Panel IA — Parte 4. Migrado desde /equipo. La lógica
// (componentes MemberList, AddMemberModal, EditRoleModal, etc.) NO se
// toca — solo cambia la envoltura: ahora vive dentro del Settings
// layout en lugar de página standalone con sidebar principal.
//
// La ruta /equipo se mantiene como redirect a /settings/team para no
// romper bookmarks ni links internos.

export const Route = createFileRoute('/_app/settings/team')({
  component: TeamPage,
});

function TeamPage() {
  const role = useCurrentUserRole();
  const { data: members, isLoading } = useTeamMembers();
  const [addOpen, setAddOpen] = useState(false);

  return (
    <div className="flex flex-col gap-6">
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold">Equipo</h1>
          <p className="text-sm text-[color:var(--color-fg-muted)]">
            Gestión de miembros y permisos
          </p>
        </div>
        {can(role, 'team.create') ? (
          <Button onClick={() => setAddOpen(true)}>
            <Plus className="mr-1.5 h-4 w-4" aria-hidden />
            Agregar miembro
          </Button>
        ) : null}
      </header>

      <MemberList members={members} isLoading={isLoading} currentUserRole={role} />

      <AddMemberModal open={addOpen} onClose={() => setAddOpen(false)} />
    </div>
  );
}
